var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.413,
    height: 29.121,
    viewBox: "0 0 30.413 29.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "video-content-icon",
    d: "M4.888,6.758H25.525a1.166,1.166,0,0,1,1.161,1.161v8.61a1.166,1.166,0,0,1-1.161,1.158H4.888A1.166,1.166,0,0,1,3.727,16.53V7.919A1.163,1.163,0,0,1,4.888,6.758Zm2.124,13.7H19.5a.22.22,0,0,1,.22.218v.814a.218.218,0,0,1-.22.218H7.012a.218.218,0,0,1-.218-.218v-.814A.22.22,0,0,1,7.012,20.457Zm-2.7,0H5.353a.22.22,0,0,1,.218.218v.814a.218.218,0,0,1-.218.218H4.316a.218.218,0,0,1-.22-.218v-.814A.22.22,0,0,1,4.316,20.457ZM4.4,24.086H26.279c.168,0,.3.208.3.455v.166c0,.247-.139.455-.3.455H4.4c-.166,0-.3-.205-.3-.455v-.166C4.1,24.294,4.232,24.086,4.4,24.086ZM29.106,4.808H1.307V27.877h27.8Zm-8.89-3.277a.97.97,0,1,1-.689.284.973.973,0,0,1,.689-.284Zm6.826,0a.973.973,0,1,1-.973.973.973.973,0,0,1,.973-.973Zm-3.413,0a.973.973,0,1,1-.973.973.973.973,0,0,1,.973-.973ZM.653,0H29.759a.636.636,0,0,1,.653.621V28.5a.639.639,0,0,1-.653.621H.653A.639.639,0,0,1,0,28.5V.62A.636.636,0,0,1,.653,0ZM13.612,9.09l3.819,2.663a.559.559,0,0,1,.166.158.569.569,0,0,1-.146.792l-3.8,2.641a.572.572,0,0,1-.933-.445V9.555h0a.572.572,0,0,1,.9-.465Z",
    transform: "translate(0 0.001)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/Content .e30c8e351031109170beaf97988e5da8.svg";
export { ForwardRef as ReactComponent };